import { urlMapping } from '@/lib/utils/url-mapping';

export default function ({domain, value}) {
  let record = urlMapping.find(
    (record) => {
      return (record.altIdDomain === domain || record.altIdType === domain) && record.ui === true;
    }
  )
  // console.log(record, _domain, value);
  if (record) {
    return (
      <a className="text-theme-blue" href={record.uriTemplate.replace("{0}", value)} target="_blank">{value}</a>
    )
  }
  return value
}
